import type { ReactNode } from "react";

/**
 * Every list and view has a designed empty state that says what to do next. A blank area reads
 * as a broken page; this reads as an invitation.
 */
export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="nb-card grid justify-items-center gap-s5 px-s7 py-s8 text-center">
      <span aria-hidden="true" className="block h-s4 w-s8 rounded-control bg-drop opacity-60" />
      <div className="grid gap-s3">
        <h2 className="text-title font-medium text-ink">{title}</h2>
        <p className="mx-auto max-w-[42ch] text-body text-muted">{description}</p>
      </div>
      {action}
    </div>
  );
}
